(function () {
  if (window.__erosShellPredictiveSkeletonBound) return;
  window.__erosShellPredictiveSkeletonBound = true;

  var ROW_COUNT = 4;
  var SKELETON_ATTR = 'data-eros-search-skeleton';

  function getPredictiveElements() {
    // ADR-177: no longer a <predictive-search> custom element (see
    // eros-hybrid-search.js) — match by class only.
    return Array.prototype.slice.call(
      document.querySelectorAll('.eros-shell-search-bar__predictive')
    );
  }

  function getResultsSlot(predictive) {
    return predictive.querySelector('[slot="results"]');
  }

  function getSearchInput(predictive) {
    var id = predictive.id;
    if (!id) return null;
    var form = document.querySelector('[aria-owns="' + id + '"]');
    return form && form.elements && form.elements.q ? form.elements.q : null;
  }

  function buildSkeleton() {
    var root = document.createElement('div');
    root.className = 'eros-shell-search-skeleton';
    root.setAttribute(SKELETON_ATTR, '');

    for (var i = 0; i < ROW_COUNT; i += 1) {
      var row = document.createElement('div');
      row.className = 'eros-shell-search-skeleton__row';

      var thumb = document.createElement('div');
      thumb.className = 'eros-shell-search-skeleton__thumb';
      thumb.setAttribute('aria-hidden', 'true');

      var lines = document.createElement('div');
      lines.className = 'eros-shell-search-skeleton__lines';

      var linePrimary = document.createElement('div');
      linePrimary.className = 'eros-shell-search-skeleton__line';
      linePrimary.setAttribute('aria-hidden', 'true');

      var lineSecondary = document.createElement('div');
      lineSecondary.className = 'eros-shell-search-skeleton__line eros-shell-search-skeleton__line--short';
      lineSecondary.setAttribute('aria-hidden', 'true');

      lines.appendChild(linePrimary);
      lines.appendChild(lineSecondary);
      row.appendChild(thumb);
      row.appendChild(lines);
      root.appendChild(row);
    }

    return root;
  }

  function hasRealResults(slot) {
    return !!(
      slot &&
      slot.querySelector('.eros-shell-search-results, .predictive-search__no-results')
    );
  }

  function showSkeleton(slot) {
    if (!slot || hasRealResults(slot)) return;
    slot.replaceChildren(buildSkeleton());
  }

  function clearSkeleton(slot) {
    if (!slot) return;
    if (!slot.querySelector('[' + SKELETON_ATTR + ']')) return;
    slot.replaceChildren();
  }

  function bindPredictive(predictive) {
    var slot = getResultsSlot(predictive);
    var input = getSearchInput(predictive);
    if (!slot || !input) return;

    input.addEventListener('input', function () {
      if (input.value.trim() === '') {
        clearSkeleton(slot);
        return;
      }
      showSkeleton(slot);
    });

    input.form &&
      input.form.addEventListener('reset', function () {
        clearSkeleton(slot);
      });
  }

  function init() {
    getPredictiveElements().forEach(bindPredictive);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
